import { useUserTrialDetails } from '@revelio/auth';

import { useTrialUserBlurToast } from './useTrialUserBlurToast';

export function useTrialUserBlurLogic() {
  const { isTrialUser } = useUserTrialDetails<boolean>({
    initialRenderValue: false,
  });
  const showBlurToast = useTrialUserBlurToast();

  return { isTrialUser, showBlurToast };
}
